<template>
  <div>
    <audio
      @timeupdate="updateProgress"
      controls
      ref="audioRef"
      style="display: none"
    >
      <source :src="fileurl" />
      您的浏览器不支持音频播放
    </audio>
    <div class="audio-right">
      <i
        :class="
          audioStatus !== 'pause'
            ? 'iconfont icon-bofang'
            : 'iconfont icon-zanting'
        "
        @click="playAudio"
        class="dialogAudioPlay"
      ></i>
      <div class="audio-time" style="min-height: 10px">
        <span class="audio-length-current" id="audioCurTime">{{
          audioStart
        }}</span>
      </div>
      <div class="progress-bar-bg" id="progressBarBg" v-dragto="setAudioIcon">
        <div class="progress-bar" id="progressBar"></div>
      </div>
      <div class="audio-time" style="min-height: 10px">
        <span class="audio-length-total">{{ duration }}</span>
      </div>
      <div class="volume">
        <div
          @click.stop="
            () => {
              return false;
            }
          "
          class="volume-progress"
          v-show="audioHuds"
        >
          <div
            class="volume-bar-bg"
            id="volumeBarBg"
            v-adjuster="handleShowMuteIcon"
          >
            <div class="volume-bar" id="volumeBar"></div>
          </div>
        </div>
        <i
          class="iconfont pl-1"
          :class="audioIcon"
          @click.stop="audioHuds = !audioHuds"
        >
        </i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fileurl: {
      trpe: String,
    },
  },
  data() {
    return {
      audioStatus: "play",
      audioStart: "0:00",
      duration: "0:00",
      audioVolume: 0.5,
      audioHuds: false,
    };
  },

  directives: {
    dragto: {
      inserted: function (el, binding, vnode) {
        el.addEventListener(
          "click",
          (e) => {
            let wdiv = document.getElementById("progressBarBg").clientWidth;
            let audio = vnode.context.$refs.audioRef;
            // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
            let ratemin = e.offsetX / wdiv;
            let rate = ratemin * 100;
            document.getElementById("progressBar").style.width = rate + "%";
            audio.currentTime = audio.duration * ratemin;
            audio.play();
            binding.value();
          },
          false
        );
      },
    },
    adjuster: {
      inserted: function (el, binding, vnode) {
        el.addEventListener(
          "click",
          (e) => {
            let hdiv = document.getElementById("volumeBarBg").clientHeight;
            let audio = vnode.context.$refs.audioRef;
            // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
            let ratemin = e.offsetY / hdiv;
            let rate = ratemin * 100;
            document.getElementById("volumeBar").style.height = rate + "%";
            audio.volume = ratemin;
            binding.value(rate / 100);
          },
          false
        );
      },
    },
  },
  computed: {
    audioIcon() {
      if (this.audioHuds) {
        return this.audioVolume < 0.01
          ? "checked icon-jingyin"
          : "checked icon-shengyin";
      } else {
        return "icon-shengyin";
      }
    },
  },
  mounted() {
    this.fetch();
  },
  watch: {
    fileurl: function () {
      this.$refs.audioRef.src = this.fileurl;
      this.fetch();
      this.audioStatus = "play"; // 显示播放icon
      document.getElementById("progressBar").style.width = "0%"; // 进度条初
    },
  },
  methods: {
    fetch() {
      let that = this;
      var myVid = this.$refs.audioRef;
      myVid.loop = false;
      // 监听音频播放完毕
      myVid.addEventListener(
        "ended",
        function () {
          that.audioStatus = "play"; // 显示播放icon
          document.getElementById("progressBar").style.width = "0%"; // 进度条初始化
        },
        false
      );
      if (myVid != null) {
        myVid.oncanplay = function () {
          that.duration = that.transTime(myVid.duration); // 计算音频时长
        };
        myVid.volume = 0.5; // 设置音量50%
      }
    },
    // 播放暂停控制
    playAudio() {
      let recordAudio = this.$refs.audioRef; // 获取audio元素
      if (recordAudio.paused) {
        recordAudio.play();
        this.audioStatus = "pause";
      } else {
        recordAudio.pause();
        this.audioStatus = "play";
      }
    },
    pauseAudio() {
      let recordAudio = this.$refs.audioRef; // 获取audio元素
      if (!recordAudio.paused) {
        recordAudio.pause();
        this.audioStatus = "play";
      }
    },
    // 更新进度条与当前播放时间
    updateProgress(e) {
      var value = e.target.currentTime / e.target.duration;
      if (document.getElementById("progressBar")) {
        document.getElementById("progressBar").style.width = value * 100 + "%";
        if (e.target.currentTime === e.target.duration) {
          this.audioStatus = "pause";
        }
      } else {
        this.audioStatus = "pause";
      }

      this.audioStart = this.transTime(this.$refs.audioRef.currentTime);
    },
    /**
     * 音频播放时间换算
     * @param {number} value - 音频当前播放时间，单位秒
     */
    transTime(time) {
      var duration = parseInt(time);
      var minute = parseInt(duration / 60);
      var sec = (duration % 60) + "";
      var isM0 = ":";
      if (minute === 0) {
        minute = "00";
      } else if (minute < 10) {
        minute = "0" + minute;
      }
      if (sec.length === 1) {
        sec = "0" + sec;
      }
      return minute + isM0 + sec;
    },
    setAudioIcon() {
      this.audioStatus = "pause";
    },
    handleShowMuteIcon(val) {
      this.audioVolume = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.volume {
  position: relative;

  .volume-progress {
    position: absolute;
    top: -120px;
    width: 32px;
    height: 140px;
    padding-top: 10px;
    background: #f6f6f6;
    border-radius: 4px;
  }

  .volume-bar-bg {
    position: relative;
    flex: 1;
    width: 6px;
    height: 120px;
    margin: 0 auto;
    cursor: pointer;
    background: #dcdcdc;
    border-radius: 100px;
    transform: rotate(180deg);

    .volume-bar {
      width: 6px;
      height: 50%;
      background: rgb(0 71 255 / 100%);
      border-radius: 100px;
    }
  }

  .checked {
    color: #56bf8b;
  }
}

.audio-right {
  position: relative;
  top: 1px;
  display: flex;
  width: 768px;
  height: 103px;
  padding: 0 15px;
  margin-top: 30px;
  line-height: 103px;
  background: rgb(0 71 255 / 100%);
  border-radius: 0;

  .icon-bofang {
    width: 60px;
    height: 60px;
    margin-top: 20px;
    background-image: url("@/assets/play.png");
    background-size: 100% 100%;
  }

  .icon-zanting {
    width: 60px;
    height: 60px;
    margin-top: 20px;
    background-image: url("@/assets/pause.png");
    background-size: 100% 100%;
  }

  .icon-shengyin {
    display: inline-block;
    width: 34px;
    height: 34px;
    margin-top: 35px;
    cursor: pointer;
    background-image: url("@/assets/audio.png");
    background-size: 100% 100%;
  }

  .icon-jingyin {
    display: inline-block;
    width: 34px;
    height: 34px;
    margin-top: 35px;
    cursor: pointer;
    background-image: url("@/assets/jingyin.png");
    background-size: 100% 100%;
  }

  .dialogAudioPlay {
    font-size: 20px;
    color: #5c5e66;
    cursor: pointer;
  }

  .progress-bar-bg {
    position: relative;
    top: 50%;
    flex: 1;
    height: 5px;
    margin: 0 10px;
    margin-top: -1px;
    cursor: pointer;
    background-color: #fff;
    border-radius: 5px;
    transform: translateY(-50%);
  }

  .progress-bar {
    width: 0%;
    height: 5px;
    background-color: #fd3732;
    border-radius: 5px;
  }

  .audio-time {
    margin: 0 20px;
    overflow: hidden;
    font-size: 18px;
    color: white;

    .audio-length-total {
      float: right;
    }

    .audio-length-current {
      float: left;
    }
  }
}
</style>
